// @ts-nocheck
import React, { useState } from "react";
import { Typography, Box, IconButton, Button } from "@mui/material";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import { Delete } from "@mui/icons-material";
import Info from "../../../assets/info.png";
import { textColor } from "../../../utils/commonstyle";

const DocumentVerificationFailed = () => {
  const [files, setFiles] = useState([]);
  const [error, setError] = useState("");

  // File size limit (5MB)
  const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
  const ALLOWED_FILE_TYPES = [".jpg", ".jpeg", ".png", ".pdf"];

  // Handle file selection and validation
  const handleFileChange = (event) => {
    const uploadedFiles = Array.from(event.target.files);
    let validFiles = [];
    let errorMessage = "";

    // Validate file types and sizes
    uploadedFiles.forEach((file) => {
      const fileExtension = file.name.slice(((file.name.lastIndexOf(".") - 1) >>> 0) + 2).toLowerCase();

      if (!ALLOWED_FILE_TYPES.includes(`.${fileExtension}`)) {
        errorMessage = `Invalid file type. Allowed types are: ${ALLOWED_FILE_TYPES.join(", ")}`;
      } else if (file.size > MAX_FILE_SIZE) {
        errorMessage = "The uploaded file exceeds the maximum allowed size of 5 MB. Please upload a smaller file.";
      } else {
        validFiles.push(file);
      }
    });

    // If there is an error, set the error state, otherwise update the files
    if (errorMessage) {
      setError(errorMessage);
    } else {
      setError("");
      setFiles((prev) => [...prev, ...validFiles]);
    }
  };

  const handleRemoveFile = (index) => {
    setFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSubmit = () => {
    console.log("Submitted Documents:", files);
  };

  return (
    <Box
      data-testid="document-verification-container"
      sx={{
        maxWidth: { xs: "90%", md: "45%" },
        mx: "auto",
        my: 2,
        p: 4,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        bgcolor: "background.paper",
      }}
    >
      <Typography
        data-testid="header-title"
        variant="h5"
        sx={{
          fontWeight: "bold",
          fontSize: { xs: "1.25rem", md: "1.5rem", xl: "1.625rem" },
          color: textColor.dark,
          mb: 2,
          textAlign: "center",
        }}
      >
        Additional Documents Required
      </Typography>
      <Typography
        data-testid="instructions-text"
        textAlign="center"
        fontWeight={400}
        fontSize={14}
        color={textColor.primaryFont}
        sx={{
          whiteSpace: 'normal',
          wordBreak: 'break-word', // or 'break-all' for aggressive breaks
        }}
      >
        There seems to be an issue with the document you uploaded. Please review the document requirements carefully and re-upload it after ensuring all criteria are met.
      </Typography>
      <Box
        data-testid="document-requirements-info"
        ml="auto"
        my={1}
        color="#087CA7"
        fontSize={14}
        display="flex"
        justifyContent="end"
        p={1}
        gap={1}
        bgcolor="#DDECFB"
      >
        Document Requirements <img src={Info} alt="info" style={{ height: "16px", width: "16px", margin: "auto" }} />
      </Box>
      <Box width={"100%"} my={1} display={"flex"} fontSize={14} gap={1} textAlign={"start"}>
        <Box color={"#9FA4AB"} fontWeight={400}>Reupload this document: </Box>
        <Box color={textColor.fontColor} fontWeight={400}> Driver's Permit (Front & Back)</Box>
      </Box>
      <Box
        data-testid="file-upload-box"
        sx={{
          border: "2px dashed gray",
          borderRadius: "8px",
          p: 3,
          width: "100%",
          textAlign: "center",
          cursor: "pointer",
        }}
        onClick={() => document.getElementById("fileUpload").click()}
      >
        <input
          type="file"
          data-testid="file-upload-input"
          id="fileUpload"
          accept=".jpg,.jpeg,.png,.pdf"
          style={{ display: "none" }}
          onChange={handleFileChange}
        />
        <IconButton data-testid="upload-icon">
          <CloudUploadOutlinedIcon sx={{ fontSize: "32px" }} />
        </IconButton>
        <Typography fontSize={16}>Click or drag files here to upload</Typography>
        <Typography fontSize={14}>.jpg, .jpeg, .png, or .pdf. Maximum 5MB.</Typography>
      </Box>

      {error && (
        <Typography data-testid="error-message" color="error" sx={{ mt: 2 }}>
          {error}
        </Typography>
      )}

      {files.length > 0 && (
        <Box data-testid="file-list" mt={3} width="100%">
          {files.map((file, index) => (
            <Box
              key={index}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              p={1}
              mb={1}
              bgcolor="whitesmoke"
              borderRadius="4px"
            >
              <Typography data-testid={`file-name-${index}`}>{file.name}</Typography>
              <Button
                data-testid={`remove-file-button-${index}`}
                size="small"
                color="error"
                onClick={() => handleRemoveFile(index)}
              >
                <Delete />
              </Button>
            </Box>
          ))}
        </Box>
      )}

      <Button
        data-testid="submit-button"
        variant="contained"
        onClick={handleSubmit}
        sx={{ mt: 3 }}
      >
        Submit
      </Button>
    </Box>
  );
};

export default DocumentVerificationFailed;
